/**
 * Application configuration properties.
 */
export class CommonsConfig {
  name: string;
  version: string|number;
}
